document.addEventListener('DOMContentLoaded', function () {
  // =========================================
  // 1) Discount popup + cookie wrapper watcher
  // =========================================
  let previouslyFocusedElement = null;
  let hasTimerStarted = false;

  function getCookie(name) {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  function setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/`;
  }

  function onKeydown(event) {
    const discountPopup = document.getElementById('discount-popup');
    if (event.key === 'Escape' && discountPopup && discountPopup.style.display === 'block') {
      closePopup();
    }
  }

  function showDiscountPopup() {
    const discountPopup = document.getElementById('discount-popup');
    if (!discountPopup) return;

    if (getCookie('visitedBefore')) return;
    if (discountPopup.style.display === 'block') return;

    previouslyFocusedElement = document.activeElement;
    discountPopup.style.display = 'block';

    const popupContent = document.getElementById('popup-content');
    if (popupContent) {
      if (!popupContent.hasAttribute('tabindex')) {
        popupContent.setAttribute('tabindex', '-1');
      }
      try { popupContent.focus(); } catch (e) {}
    }

    document.addEventListener('keydown', onKeydown);
  }

  function startDiscountTimer() {
    if (hasTimerStarted) return;
    hasTimerStarted = true;

    if (getCookie('visitedBefore')) return;

    setTimeout(showDiscountPopup, 15000);
  }

  window.closePopup = function () {
    const discountPopup = document.getElementById('discount-popup');
    if (discountPopup) {
      discountPopup.style.display = 'none';
    }

    setCookie('visitedBefore', 'true', 15);
    document.removeEventListener('keydown', onKeydown);

    if (previouslyFocusedElement && document.contains(previouslyFocusedElement)) {
      try { previouslyFocusedElement.focus(); } catch (e) {}
    }
  };

  function attachWrapperObserver(wrapper) {
    let hasSeenBannerContent = wrapper.childElementCount > 0;

    const observer = new MutationObserver(function () {
      const hasContentNow = wrapper.childElementCount > 0;

      if (!hasSeenBannerContent && hasContentNow) {
        hasSeenBannerContent = true;
      }

      if (hasSeenBannerContent && !hasContentNow) {
        observer.disconnect();
        startDiscountTimer();
      }
    });

    observer.observe(wrapper, { childList: true, subtree: false });

    setTimeout(function () {
      if (!hasTimerStarted && !hasSeenBannerContent && wrapper.childElementCount === 0) {
        observer.disconnect();
        startDiscountTimer();
      }
    }, 5000);

    setTimeout(function () {
      if (!hasTimerStarted) {
        observer.disconnect();
      }
    }, 120000);
  }

  function initCookieWrapperWatcher() {
    let wrapper = document.getElementById('csm-wrapper');
    if (wrapper) {
      attachWrapperObserver(wrapper);
      return;
    }

    const bodyObserver = new MutationObserver(function () {
      wrapper = document.getElementById('csm-wrapper');
      if (wrapper) {
        bodyObserver.disconnect();
        attachWrapperObserver(wrapper);
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });

    setTimeout(function () {
      if (!hasTimerStarted) {
        bodyObserver.disconnect();
        wrapper = document.getElementById('csm-wrapper');
        if (wrapper) {
          attachWrapperObserver(wrapper);
        } else {
          startDiscountTimer();
        }
      }
    }, 10000);
  }

  initCookieWrapperWatcher();

  // =========================================
  // 2) Consentmo a11y for custom trigger button
  //    (footer "Cookie Preferences")
  // =========================================
  let lastPreferencesTrigger = null;

  function returnFocusToTrigger() {
    if (lastPreferencesTrigger && document.body.contains(lastPreferencesTrigger)) {
      try {
        lastPreferencesTrigger.focus();
      } catch (e) {
        //console.warn('Unable to return focus to cookie preferences trigger:', e);
      }
    }
  }

  document.addEventListener('click', function (event) {
    const footerTrigger = event.target.closest('.isense-reopen-widget-link');
    if (footerTrigger) {
      lastPreferencesTrigger = footerTrigger;
    }
  });

  document.addEventListener('click', function (event) {
    const actionBtn = event.target.closest(
      '.cc-btn-close-settings, .isense-cc-btn-accept-selected, .isense-cc-btn-accept-all'
    );
    if (!actionBtn) return;
    setTimeout(returnFocusToTrigger, 0);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!lastPreferencesTrigger) return;

    const dialog = document.querySelector('.isense-cc-window');
    if (!dialog) return;

    const isHidden =
      dialog.getAttribute('aria-hidden') === 'true' ||
      dialog.style.display === 'none';

    if (!isHidden) {
      setTimeout(returnFocusToTrigger, 20);
    }
  });

  // =========================================
  // 3) Consentmo: adjust policy link in cookie banner
  // =========================================
  function initLinkObserver(wrapper) {
    if (!wrapper) return;
    if (!('MutationObserver' in window)) return;

    let hasCleanedLink = false;

    function cleanConsentmoLinks(root) {
      const scope = root || document;
      const links = [];

      if (scope.matches && scope.matches('a.isense-cc-link')) {
        links.push(scope);
      }

      if (scope.querySelectorAll) {
        scope.querySelectorAll('a.isense-cc-link').forEach(function (link) {
          if (links.indexOf(link) === -1) {
            links.push(link);
          }
        });
      }

      if (!links.length) return;

      hasCleanedLink = true;

      links.forEach(function (link) {
        if (link.hasAttribute('target')) {
          link.removeAttribute('target');
        }
        if (link.hasAttribute('aria-label')) {
          link.removeAttribute('aria-label');
        }
      });
    }

    // Clean anything already present
    cleanConsentmoLinks(wrapper);

    const linkObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches('a.isense-cc-link')) {
            cleanConsentmoLinks(node);
          } else if (node.querySelectorAll) {
            cleanConsentmoLinks(node);
          }
        });
      });

      // Once we've cleaned at least one link and there are no more,
      // disconnect observer for this user session.
      if (hasCleanedLink && !wrapper.querySelector('a.isense-cc-link')) {
        linkObserver.disconnect();
      }
    });

    linkObserver.observe(wrapper, {
      childList: true,
      subtree: true
    });
  }

  let wrapper = document.getElementById('csm-wrapper');
  if (wrapper) {
    initLinkObserver(wrapper);
  } else if ('MutationObserver' in window) {
    const bodyObserver = new MutationObserver(function (mutations, observer) {
      wrapper = document.getElementById('csm-wrapper');
      if (wrapper) {
        observer.disconnect();
        initLinkObserver(wrapper);
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });

    setTimeout(function () {
      bodyObserver.disconnect();
      wrapper = document.getElementById('csm-wrapper');
      if (wrapper) {
        initLinkObserver(wrapper);
      }
    }, 10000);
  }
});
